<div class="container mx-auto p-4">
  <h2 class="text-2xl font-bold mb-4">Project Appointments</h2>
  
  <!-- Add/Edit Appointment Form -->
  <div class="mb-4 p-4 bg-gray-100 rounded">
    <form (ngSubmit)="editingAppointment ? updateAppointment(noteForm) : addAppointment(noteForm)" #noteForm="ngForm">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label for="title" class="block text-sm font-medium">Title</label>
          <input type="text" id="title" [(ngModel)]="newAppointment.title" name="title" 
                 class="w-full p-2 border rounded" required>
        </div>
        <div>
          <label for="userGuid" class="block text-sm font-medium">User GUID</label>
          <input type="text" id="userGuid" [(ngModel)]="newAppointment.userGuid" name="userGuid" 
                 class="w-full p-2 border rounded" required>
        </div>
        <div>
          <label for="startTime" class="block text-sm font-medium">Start Time</label>
          <input type="datetime-local" id="startTime" [(ngModel)]="newAppointment.startTime" name="startTime" 
                 class="w-full p-2 border rounded">
        </div>
        <div>
          <label for="endTime" class="block text-sm font-medium">End Time</label>
          <input type="datetime-local" id="endTime" [(ngModel)]="newAppointment.endTime" name="endTime" 
                 class="w-full p-2 border rounded">
        </div>
        <div>
          <label for="location" class="block text-sm font-medium">Location</label>
          <input type="text" id="location" [(ngModel)]="newAppointment.location" name="location" 
                 class="w-full p-2 border rounded">
        </div>
        <div>
          <label for="description" class="block text-sm font-medium">Description</label>
          <textarea id="description" [(ngModel)]="newAppointment.description" name="description" 
                    class="w-full p-2 border rounded"></textarea>
        </div>
      </div>
      <button type="submit" class="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              [disabled]="!noteForm.valid">{{ editingAppointment ? 'Update Appointment' : 'Add Appointment' }}</button>
      <button type="button" *ngIf="editingAppointment" (click)="resetForm()" 
              class="mt-4 ml-2 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700">Cancel</button>
    </form>
  </div>

  <!-- Appointments Table -->
  <div class="overflow-x-auto">
    <table class="w-full border-collapse bg-white shadow-md rounded">
      <thead>
        <tr class="bg-gray-200">
          <th class="p-3 text-left">ID</th>
          <th class="p-3 text-left">Project ID</th>
          <th class="p-3 text-left">Title</th>
          <th class="p-3 text-left">Start Time</th>
          <th class="p-3 text-left">End Time</th>
          <th class="p-3 text-left">Location</th>
          <th class="p-3 text-left">Description</th>
          <th class="p-3 text-left">User GUID</th>
          <th class="p-3 text-left">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let appointment of appointments" class="border-b hover:bg-gray-50">
          <td class="p-3">{{appointment.id}}</td>
          <td class="p-3">{{appointment.projectId}}</td>
          <td class="p-3">{{appointment.title}}</td>
          <td class="p-3">{{appointment.startTime | date:'short'}}</td>
          <td class="p-3">{{appointment.endTime | date:'short'}}</td>
          <td class="p-3">{{appointment.location}}</td>
          <td class="p-3">{{appointment.description}}</td>
          <td class="p-3">{{appointment.userGuid}}</td>
          <td class="p-3">
            <button (click)="editAppointment(appointment)" class="mr-2 text-blue-600 hover:text-blue-800">Edit</button>
            <button (click)="deleteAppointment(appointment.id)" class="text-red-600 hover:text-red-800">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>